import translates from './az.json';
import restNotifications from './notifiers.json';

export default {
  az: { ...translates, ...restNotifications },
};
